import React, { useState } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const ChartComponent = ({ data }) => {
  const [currentDate, setCurrentDate] = useState(new Date()); // Default to today

  // Format a date to a readable string (e.g., "Mon, Nov 11, 2024")
  const formatDate = (date) => date.toDateString();

  // Move to the previous or next day
  const changeDate = (days) => {
    const newDate = new Date(currentDate);
    newDate.setDate(currentDate.getDate() + days);
    setCurrentDate(newDate);
  };

  // Filter data for the current day
  const filteredData = data.filter(
    (item) => new Date(item.start).toDateString() === formatDate(currentDate)
  );

  // Count consultations per hour
  const hourlyConsultations = Array(24).fill(0); // Array of 24 hours
  filteredData.forEach((item) => {
    const startHour = new Date(item.start).getHours();
    hourlyConsultations[startHour]++;
  });

  // Generate labels (hours of the day)
  const labels = Array.from({ length: 24 }, (_, i) => `${i}:00`);

  // Chart data configuration
  const chartData = {
    labels,
    datasets: [
      {
        label: "Number of Consultations",
        data: hourlyConsultations,
        borderColor: "rgba(54, 162, 235, 1)",
        backgroundColor: "rgba(54, 162, 235, 0.2)",
        fill: true,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
    },
    scales: {
      x: {
        title: { display: true, text: "Hour of the Day" },
        beginAtZero: true,
      },
      y: {
        title: { display: true, text: "Number of Consultations" },
        beginAtZero: true,
      },
    },
  };

  return (
    <div>
      {/* Navigation Buttons */}
      <div className="mt-5 mb-2 flex items-center gap-x-3">
        <button
          className="w-[30px] h-[30px] rounded-md border flex items-center justify-center cursor-pointer duration-300 hover:border-primary"
          onClick={() => changeDate(-1)}
        >
          &lt;
        </button>
        <span className="font-medium">{formatDate(currentDate)}</span>
        <button
          className="w-[30px] h-[30px] rounded-md border flex items-center justify-center cursor-pointer duration-300 hover:border-primary"
          onClick={() => changeDate(1)}
          disabled={new Date().toDateString() === formatDate(currentDate)}
        >
          &gt;
        </button>
      </div>
      {/* Chart */}
      <div className="border px-3 py-2 rounded-lg">
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
};

export default ChartComponent;
